import styled from 'styled-components'

const TimeSlotSelectStyled = styled.div`
  max-width: var(--booking-module-time-slot-select-max-width);
`

export { TimeSlotSelectStyled }
